var _effectorFileName = "/builds/gmini/front-ui-kit/src/icons/Triangle.tsx";
import { jsx as _jsx } from "react/jsx-runtime";
export const Triangle = ({
  color = '#4C5ECF',
  ...other
}) => /*#__PURE__*/_jsx("svg", {
  width: "18",
  height: "18",
  viewBox: "0 0 6 4",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...other,
  children: /*#__PURE__*/_jsx("path", {
    d: "M0.222358 1.7825L2.16486 3.725C2.45736 4.0175 2.92986 4.0175 3.22236 3.725L5.16486 1.7825C5.63736 1.31 5.29986 0.5 4.63236 0.5H0.747358C0.0798578 0.5 -0.250142 1.31 0.222358 1.7825Z",
    fill: color
  })
});